import React from 'react';
import SectionTitle from '@/ui/SectionTitle/SectionTitle';
import { Internet } from '@/icons/section';
import SliderWrapper from '@/ui/SliderWrapper/SliderWrapper';
import {
  Tab,
  TabContent,
  TabContentItem,
  TabPanel,
  Tabs,
  TariffCard,
} from '@/ui/index';

import styles from '../Tariffs/styles.module.scss';

const InternetBundles = ({ tabs, item }) => {
  const [currentTab, setCurrentTab] = React.useState(0);

  const renderTab = (tab, index) => {
    return (
      <Tab
        key={index}
        onClick={() => setCurrentTab(index)}
        itemScope
        itemType='https://schema.org/Offer'
      >
        {tab?.title || null}
      </Tab>
    );
  };

  const renderSlider = (tariff, index) => {
    return (
      <TariffCard
        key={`${index}_tariff`}
        item={tariff}
        itemScope
        itemType='https://schema.org/Offer'
      />
    );
  };

  const renderTabItem = (index, tabItem = {}) => {
    return (
      <TabContentItem
        key={index}
        itemScope
        itemType='https://schema.org/ItemList'
      >
        {!!tabItem?.tariffs?.length && (
          <SliderWrapper arrows>
            {tabItem.tariffs.map(renderSlider)}
          </SliderWrapper>
        )}
      </TabContentItem>
    );
  };

  return (
    <div className={'section'} itemScope itemType='https://schema.org/Service'>
      <SectionTitle
        Icon={Internet}
        buttonText={item?.button_text}
        className={'wrapper'}
        titleModify='title--large'
        href={item?.button_slug}
      >
        {item?.title}
      </SectionTitle>
      <Tabs active={currentTab}>
        <TabPanel className={`${styles.panner} wrapper`}>
          {tabs.map(renderTab)}
        </TabPanel>
        <TabContent>{tabs.map(renderTabItem)}</TabContent>
      </Tabs>
    </div>
  );
};

export default InternetBundles;
